module.exports = __webpack_public_path__ + "media/images/s02_02_pt-c56163a11e62a02224a7002b669541d7.svg";